import React from "react";

export type AccessibilityContextValue = {
  announceForAccessibility: (announcement: string) => void;
};

export const AccessibilityContext =
  React.createContext<AccessibilityContextValue>({
    announceForAccessibility: () => {},
  });
